import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { NotifyContext } from '../Library/Notify'
import { HeaderTitle } from '../Library'
import { createAlbum } from '../Network/Gallery'
import { useHistory } from 'react-router-dom'
import { setDocumentTitle } from '../AppTitle'
import "./CreateAlbum.css"

function CreateAlbum() {
    const history = useHistory()
    const notify = useContext(NotifyContext)
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.gallery
    const [albumName, setAlbumName] = useState("");
    const [description, setDescription] = useState("");
    const [purpose, setPurpose] = useState("News");
    const [isError, setError] = useState(false)

    const onSubmit = () =>{
        if(!albumName || !description || !purpose){
            notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true)
            return;
        }

        createAlbum(albumName, description, purpose,
            ()=>{
                history.push("/gallery")
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
            })
    }
    
    useEffect(()=>{
        setDocumentTitle("Create Album")
    },[])

    return (
        <div id="create-gallery">
            <HeaderTitle title={lang.create_album} isShowBack backTo="/gallery"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form 
                    onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.album_name}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !albumName}
                            value={albumName}
                            onChange={(e)=>setAlbumName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.album_description}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !description}
                            value={description}
                            onChange={(e)=>setDescription(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.purpose}</Form.Label>
                            <Form.Control
                            isInvalid={isError && !purpose}
                            value={purpose}
                            disabled={true}
                            onChange={(e)=>setPurpose(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Button
                        type="submit">
                            {lang.create_album}
                        </Button>
                        
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default CreateAlbum
